import apiClient from './apiClient';

export interface Veterinarian {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role: 'veterinarian';
  clinicId: string;
  clinicName?: string;
  status: 'active' | 'inactive';
  emailVerified: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface VeterinarianFilters {
  clinicId?: string;
  status?: 'active' | 'inactive' | 'pending';
  search?: string;
}

export interface CreateVeterinarianData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  specializations?: string[];
  experienceYears?: number;
  description?: string;
  clinicId: string;
}

// Serviciul pentru veterinari folosind apiClient

// Serviciul pentru veterinari
export const veterinariansService = {
  // Obtine toti veterinarii cu filtrare optionala
  async getVeterinarians(filters?: VeterinarianFilters): Promise<Veterinarian[]> {
    try {
      const params = new URLSearchParams();
      params.append('role', 'veterinarian');
      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            params.append(key, value.toString());
          }
        });
      }

      const url = `?${params.toString()}`;
      const response = await apiClient.get(`/users${url}`);

      return response.data.data || [];
    } catch (error: any) {
      if (error.response?.status === 401) {
        throw new Error('Token invalid. Te rugam sa te autentifici din nou.');
      } else if (error.response?.status === 403) {
        throw new Error('Nu ai permisiuni pentru aceasta actiune.');
      } else if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      } else {
        throw new Error('Eroare la incarcarea veterinarilor. Verifica conexiunea la internet.');
      }
    }
  },

  // Obtine un veterinar specific dupa ID
  async getVeterinarian(id: string): Promise<Veterinarian> {
    try {
            const response = await apiClient.get(`/users/${id}`);
            return response.data;
    } catch (error) {
            throw new Error('Eroare la incarcarea veterinarului');
    }
  },

  // Obtine veterinarii activi
  async getActiveVeterinarians(): Promise<Veterinarian[]> {
    return this.getVeterinarians({ status: 'active' });
  },

  // Obtine veterinarii dintr-o clinica specifica
  async getVeterinariansByClinic(clinicId: string): Promise<Veterinarian[]> {
    return this.getVeterinarians({ clinicId, status: 'active' });
  },

  // Creeaza un nou veterinar
  async createVeterinarian(data: CreateVeterinarianData): Promise<Veterinarian> {
    try {
      const requestData = {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phone: data.phone,
        role: 'veterinarian',
        clinicId: data.clinicId,
        specializations: data.specializations || [],
        experienceYears: data.experienceYears || 0,
        description: data.description || '',
        status: 'pending'
      };

      const response = await apiClient.post('/users', requestData);

      return response.data.data;
    } catch (error: any) {
      if (error.response?.status === 401) {
        throw new Error('Token invalid. Te rugam sa te autentifici din nou.');
      } else if (error.response?.status === 403) {
        throw new Error('Nu ai permisiuni pentru aceasta actiune.');
      } else if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      } else {
        throw new Error('Eroare la crearea veterinarului. Verifica conexiunea la internet.');
      }
    }
  }
}; 